import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBack,
  MdArrowForward,
  MdAttachFile,
  MdCancel,
  MdMenu,
  MdMoreHoriz,
  MdOutlineImage,
} from "react-icons/md";

import { useLocation, useNavigate, useParams } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import "../styles/Navbars.css";

export default function DesktopSidebar({
  mobile,
  companyData,
  authToken,
  isSeller,
  setIsSeller,
  setScrollPositionSeller,
  setScrollPositionHome,
}) {
  let location = useLocation().pathname;
  let navigate = useNavigate();

  const [isACreator, setisACreator] = useState(false);

  useEffect(() => {
    if (!isEmpty(companyData)) {
      if (companyData.isACreator == 1) {
        setIsSeller(true);
      } else {
        setIsSeller(false);
      }
    }
  }, [companyData]);

  const handleNavigateClick = (destination, source) => {
    if (location == "/") {
      setScrollPositionHome(window.scrollY);
    }
    if (location == "/seller") {
      setScrollPositionSeller(window.scrollY);
    }
    window.scrollTo(0, 0);

    navigate(destination);
  };

  return (
    <div className="desktopsidebar">
      <div className="desktopsidebar_logo">doodli</div>
      <div className="desktopsidebar_navbar">
        <div
          className="desktopsidebar_navbar_element button"
          onClick={() => location != "/" && handleNavigateClick("/")}>
          {" "}
          {location == "/" ? (
            <div className="active_nav">Suchen</div>
          ) : (
            "Suchen"
          )}
        </div>
        <div
          className="desktopsidebar_navbar_element button"
          onClick={() =>
            location != "/orders" && handleNavigateClick("/orders")
          }>
          {location == "/orders" ? (
            <div className="active_nav">Bestellungen</div>
          ) : (
            "Bestellungen"
          )}
        </div>
        <div
          className="desktopsidebar_navbar_element button"
          onClick={() =>
            location != "/seller" && handleNavigateClick("/seller")
          }>
          {location == "/seller" ? (
            <div className="active_nav">Stories</div>
          ) : (
            "Stories"
          )}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 33px;
  color: #575757;
`;

const ArrowBack = styled(MdArrowBack)`
  font-size: 20px;
  color: #636363;
  margin-top: 2px;
`;

const MoreIcon = styled(MdMoreHoriz)`
  font-size: 20px;
  color: #474747;
`;

const ImageIcon = styled(MdOutlineImage)`
  font-size: 30px;
  color: #474747;
`;

const SendIcon = styled(MdArrowForward)`
  font-size: 20px;
  color: #ffffff;
  transform: rotate(-90deg);
`;

const FileIcon = styled(MdAttachFile)`
  font-size: 20px;
  color: #474747;
`;

const CancelIcon = styled(MdCancel)`
  font-size: 25px;
  color: #575757;
`;
